module.exports = __webpack_public_path__ + "img/finance.3607a252.png";